import React from "react";
import { Card } from "reactstrap";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import LocationFormButton from "./LocationFormButton";

const LocationListItem = ({ item, toggleModal }) => {
  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-12">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.name}</b>
            </p>
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.city}</b>
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.address}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.openingHours}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.websiteLink}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.status}
            </p>
            <div className="w-15 w-sm-100">
              <LocationFormButton
                id={item.id}
              >
              </LocationFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};
export default React.memo(LocationListItem);
